import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { TbBarcodeOff } from 'react-icons/tb';
import { MdOutlineManageHistory } from 'react-icons/md';
import { BiBarcodeReader } from 'react-icons/bi';
import { jsPDF } from 'jspdf';

export default function WithoutBarcode() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id, subjectId, examname, subjectname } = location.state || {};
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [barcodeCount, setBarcodeCount] = useState('');
  const modalRef = useRef(); // Reference for the modal
  const [extraBarcode, setExtrabarcode] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [generatedBarcodes, setGeneratedBarcodes] = useState([]);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [count, setCount] = useState(0);
  const [loadingbr, setLoadingbr] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);
  useEffect(() => {
    fetchRecordsWithoutbarcode();
  }, []);

  // Fetch records for student withot barcode
  const fetchRecordsWithoutbarcode = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${apiUrl}/api/students/without-barcode`,
        {
          headers: {
            Authorization: token,
          },
          params: {
            examId: id, // Include examId in the request parameters
            subjectId: subjectId,
          },
        }
      );
      const { students } = response.data;
      setRecords(students);
      setLoading(false);
      setCount(response.data.totalStudents);
    } catch (error) {
      console.error('Error fetching records:', error);
      setLoading(false);
      error.response?.status === 401 && navigate('/');
    }
  };

  // columns for student withot barcode
  const baseColumns = [
    {
      name: 'No',
      selector: (row, index) => {
        // Calculate serial number based on current page and rows per page
        return (currentPage - 1) * rowsPerPage + index + 1;
      },
      width: '50px',
      center: 'true',
    },
    {
      name: 'Barcode',
      width: '100px',
      center: 'true',
      cell: (row) => (
        <div className="pt-2 fs-4 mb-2" id="table-btn ">
          <TbBarcodeOff />
        </div>
      ),
    },
    {
      name: 'Roll Number',
      selector: (row) => row.rollNumber,
      sortable: true,
      with: '150px',
      center: 'true',
    },

    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
  ];

  const ExtraBarcode = async () => {
    const token = localStorage.getItem('token');
    const info = JSON.stringify({
      examId: id,
      subjectId: subjectId,
      count: parseInt(barcodeCount), // Default to 2 if input is empty
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/emergencyBarcode`,
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
      data: info,
    };

    try {
      const response = await axios.request(config);
      setExtrabarcode(response.data);
      setBarcodeCount('');
      toast.success('Barcode generated successfully');
    } catch (error) {
      console.error('Error in ExtraBarcode:', error);
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
    }
  };

  const sendSelectedStudents = async () => {
    setLoadingbr(true);
    if (selectedRows.length === 0) {
      toast.warning('No students selected');
      setLoadingbr(false);
      return;
    }
    console.log(selectedRows, 'selectedRows');
    const token = localStorage.getItem('token');
    const data = JSON.stringify({
      examId: id,
      subjectId: subjectId,
      studentIds: selectedRows,
    });
    const config = {
      method: 'post',
      url: `${apiUrl}/api/qrCode`,
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
      data: data,
    };
    try {
      const response = await axios.request(config);
      setLoadingbr(false);
      setSelectedRows([]); // Clear selected rows
      setGeneratedBarcodes(response.data);
      setShowModal(true);
      setClearSelectedRows(!clearSelectedRows);
      toast.success('QR Codes generated successfully');
      fetchRecordsWithoutbarcode(); // Fetch records again to ensure the table is updated
    } catch (error) {
      setLoadingbr(false);
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
    }
  };

  const handleRowSelected = (state) => {
    const selectedRowIds = state.selectedRows.map((row) => row.id);
    setSelectedRows(selectedRowIds);
  };

  // Function to generate a PDF containing barcodes with student details
  const handleDownloadPDF = (barcodes, examname) => {
    // Initialize jsPDF object with a specific page size
    const pdf = new jsPDF('landscape', 'cm', [10, 2.5]); // Set page size to 10cm width x 2.5cm height

    // Helper function to truncate text to a specific length
    const truncateText = (text, maxLength) => {
      return text.length > maxLength ? text.substring(0, maxLength) + '' : text;
    };

    // Define maximum character length for display
    const maxLength = 25;

    // Loop through the barcodes and add their details to the PDF
    barcodes.forEach((barcode, index) => {
      // Reset position for each barcode section
      let yPosition = 0.6; // Starting Y position with a margin
      const leftColumnX = 0.4; // X position for text

      // Set font for the text details
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      const labelWidth = 1.5; // Minimum width for labels in cm
      const padding = 0.0; // Optional padding between label and data

      // Add Roll No, Exam, Subject, and Sub Code with character count
      pdf.text(`Roll No:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.studentRollNumber}`,
        leftColumnX + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Exam:`, leftColumnX, yPosition); // Use 'examname' instead of 'examName'
      const truncatedExamName = truncateText(examname, maxLength);
      pdf.text(
        `${truncatedExamName} `,
        leftColumnX + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Subject:`, leftColumnX, yPosition);
      const subjectName = barcode.subjectName;
      const truncatedSubjectName = truncateText(subjectName, maxLength);
      pdf.text(
        `${truncatedSubjectName}`,
        leftColumnX + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Sub Code:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.subjectCode}`,
        leftColumnX + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      // Add Barcode image if available
      if (barcode.barcodeJson?.[0]?.barcodeImage) {
        const img = new Image();
        img.src = barcode.barcodeJson[0].barcodeImage;

        // Ensure the image has the correct base64 prefix
        if (img.src.startsWith('data:image/')) {
          pdf.addImage(img, 'PNG', 6, 0.3, 3.5, 1.5); // Adjust position and size (X, Y, Width, Height)
        } else {
          console.error('Invalid base64 image format:', img.src);
        }
      }

      // Add the barcode number below the image, centered
      pdf.setFontSize(10);
      pdf.text(`${barcode.barcodeNo}`, 7.8, 2.1, { align: 'center' });

      // Add a new page for the next barcode if not the last one
      if (index !== barcodes.length - 1) {
        pdf.addPage();
      }
    });

    // Save the generated PDF file
    pdf.save('barcodes.pdf');
  };

  const handleDownloadPDF4 = (barcodes, examname) => {
    const pdf = new jsPDF('portrait', 'cm', [21, 29.7]); // A4 size in portrait (swap width and height)

    const truncateText = (text, maxLength) => {
      return text.length > maxLength ? text.substring(0, maxLength) + '' : text;
    };

    const maxLength = 25; // Max length for truncating text
    const columns = 2; // Two barcodes per row
    const rows = 8; // Eight rows per page
    const barcodeWidth = 9.5; // Width for each barcode section (cm)
    const barcodeHeight = 3; // Height for each barcode section (cm)
    const labelWidth = 1.5; // Minimum width for labels in cm
    const padding = 0.2; // Padding between label and data
    const marginTop = -2.4; // Margin to add to the top of the barcode image
    const columnGap = 1.4; // Gap between columns (in cm)
    const pageTopMargin = 1.5; // Top margin for the page (in cm)
    const rowGap = 0.5; // Gap between rows (in cm)

    let yPosition = pageTopMargin; // Start the y-position from the top margin

    barcodes.forEach((barcode, index) => {
      const column = index % columns; // Determine column (0 or 1)
      const row = Math.floor(index / columns) % rows; // Determine row (0 to 7)

      // Reset yPosition and add a new page when required
      if (index > 0 && row === 0 && column === 0) {
        pdf.addPage();
        yPosition = pageTopMargin; // Reset yPosition for the new page
      }

      let xPosition = column * (barcodeWidth + columnGap) + 0.4; // X position for text and barcode
      yPosition = pageTopMargin + row * (barcodeHeight + rowGap) + 0.6; // Y position for text and barcode

      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      pdf.text(`Roll No:`, xPosition, yPosition);
      pdf.text(
        `${barcode.studentRollNumber}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Exam:`, xPosition, yPosition);
      const truncatedExamName = truncateText(examname, maxLength);
      pdf.text(
        `${truncatedExamName} `,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Subject:`, xPosition, yPosition);
      const subjectName = barcode.subjectName;
      const truncatedSubjectName = truncateText(subjectName, maxLength);
      pdf.text(
        `${truncatedSubjectName}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Sub Code:`, xPosition, yPosition);
      pdf.text(
        `${barcode.subjectCode}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      if (barcode.barcodeJson?.[0]?.barcodeImage) {
        const img = new Image();
        img.src = barcode.barcodeJson[0].barcodeImage;

        if (img.src.startsWith('data:image/')) {
          pdf.addImage(
            img,
            'PNG',
            xPosition + 6,
            yPosition + marginTop,
            3.6,
            1.9
          ); // Adjust X, Y, Width, Height
          yPosition += 1.5; // Move the y-position after placing the barcode image
        } else {
          console.error('Invalid base64 image format:', img.src);
        }
      }

      pdf.setFontSize(10);
      pdf.text(`${barcode.barcodeNo}`, xPosition + 7.8, yPosition - 1.7, {
        align: 'center',
      });
    });

    pdf.save('barcodes.pdf');
  };

  const ERDownloadPDF = (barcodes, examname) => {
    // Initialize jsPDF object with a specific page size
    const pdf = new jsPDF('landscape', 'cm', [10, 2.5]); // Set page size to 10cm width x 2.5cm height

    // Loop through the barcodes and add their details to the PDF
    barcodes.forEach((barcode, index) => {
      // Reset position for each barcode section
      let yPosition = 0.6; // Starting Y position with a margin
      const leftColumnX = 0.4; // X position for text

      // Set font for the text details
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      const labelWidth = 1.5; // Minimum width for labels in cm
      const padding = 0.0; // Optional padding between label and data

      // Add Roll No, Exam, Subject, and Sub Code
      pdf.text(`Roll No:`, leftColumnX, yPosition);
      pdf.text(`${''}`, leftColumnX + labelWidth + padding, yPosition); // Placeholder for roll number
      yPosition += 0.5;
      pdf.text(`Exam:`, leftColumnX, yPosition); // Use 'examname' instead of 'examName'
      pdf.text(`${examname}`, leftColumnX + labelWidth + padding, yPosition); // Place data after label
      yPosition += 0.5;
      pdf.text(`Subject:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.barcodeJson.subjectName}`,
        leftColumnX + labelWidth + padding,
        yPosition
      ); // Place data after label
      yPosition += 0.5;
      pdf.text(`Sub Code:`, leftColumnX, yPosition);
      pdf.text(
        `${barcode.barcodeJson.subjectCode}`,
        leftColumnX + labelWidth + padding,
        yPosition
      ); // Place data after label
      yPosition += 0.5;

      // Add Barcode image if available
      if (barcode.barcodeJson.barcodeImage) {
        const base64Image = barcode.barcodeJson.barcodeImage;

        // Ensure the image has the correct base64 prefix
        if (base64Image.startsWith('data:image/')) {
          pdf.addImage(base64Image, 'PNG', 6, 0.3, 3.5, 1.5); // Adjust position and size (X, Y, Width, Height)
        } else {
          console.error('Invalid base64 image format:', base64Image);
        }
      }

      // Add the barcode number below the image, centered
      pdf.setFontSize(10);
      pdf.text(`${barcode.barcodeNo}`, 7.8, 2.1, { align: 'center' });

      // Add a new page for the next barcode if not the last one
      if (index !== barcodes.length - 1) {
        pdf.addPage();
      }
    });

    // Save the generated PDF file
    pdf.save('barcodes.pdf');
  };

  const ERDownloadPDFA4 = (barcodes, examname) => {
    const pdf = new jsPDF('portrait', 'cm', [21, 29.7]); // A4 size in portrait mode

    const truncateText = (text, maxLength) => {
      return text.length > maxLength
        ? text.substring(0, maxLength) + '...'
        : text;
    };

    const maxLength = 25; // Max length for truncating text
    const columns = 2; // Two barcodes per row
    const rows = 8; // Eight rows per page
    const barcodeWidth = 9.5; // Width for each barcode section (cm)
    const barcodeHeight = 3; // Height for each barcode section (cm)
    const labelWidth = 1.5; // Minimum width for labels in cm
    const padding = 0.2; // Padding between label and data
    const marginTop = -2.4; // Margin to add to the top of the barcode image
    const columnGap = 1.4; // Gap between columns (in cm)
    const pageTopMargin = 1.5; // Top margin for the page (in cm)
    const rowGap = 0.5; // Gap between rows (in cm)

    let yPosition = pageTopMargin; // Start the y-position from the top margin

    barcodes.forEach((barcode, index) => {
      const column = index % columns; // Determine column (0 or 1)
      const row = Math.floor(index / columns) % rows; // Determine row (0 to 7)

      // Reset yPosition and add a new page when required
      if (index > 0 && row === 0 && column === 0) {
        pdf.addPage();
        yPosition = pageTopMargin; // Reset yPosition for the new page
      }

      let xPosition = column * (barcodeWidth + columnGap) + 0.4; // X position for text and barcode
      yPosition = pageTopMargin + row * (barcodeHeight + rowGap) + 0.6; // Y position for text and barcode

      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(8);

      // Add Roll No, Exam, Subject, and Sub Code
      pdf.text(`Roll No:`, xPosition, yPosition);
      pdf.text(
        `${barcode.studentRollNumber || ''}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Exam:`, xPosition, yPosition);
      const truncatedExamName = truncateText(examname, maxLength);
      pdf.text(
        `${truncatedExamName}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Subject:`, xPosition, yPosition);
      const subjectName = barcode.barcodeJson?.subjectName || '';
      const truncatedSubjectName = truncateText(subjectName, maxLength);
      pdf.text(
        `${truncatedSubjectName}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      pdf.text(`Sub Code:`, xPosition, yPosition);
      pdf.text(
        `${barcode.barcodeJson.subjectCode || ''}`,
        xPosition + labelWidth + padding,
        yPosition
      );
      yPosition += 0.5;

      // Add Barcode image if available
      if (barcode.barcodeJson?.barcodeImage) {
        const base64Image = barcode.barcodeJson.barcodeImage;

        if (base64Image.startsWith('data:image/')) {
          pdf.addImage(
            base64Image,
            'PNG',
            xPosition + 6,
            yPosition + marginTop,
            3.6,
            1.9
          ); // Adjust X, Y, Width, Height
          yPosition += 1.5; // Move the y-position after placing the barcode image
        } else {
          console.error('Invalid base64 image format:', base64Image);
        }
      }

      // Add the barcode number below the image, centered
      pdf.setFontSize(10);
      pdf.text(`${barcode.barcodeNo || ''}`, xPosition + 7.8, yPosition - 1.7, {
        align: 'center',
      });
    });

    pdf.save('barcodes_a4_format.pdf');
  };

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                {' '}
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li
                className="breadcrumb-item  cursor-pointer"
                onClick={() => navigate('/ListExam')}
              >
                View Exam
              </li>
              <li
                className="breadcrumb-item cursor-pointer "
                onClick={() =>
                  navigate('/ExamDetails', {
                    state: { id, subjectId, examname, subjectname },
                  })
                }
              >
                Exam Subjects
              </li>
              <li className="breadcrumb-item active">
                Without Barcode Student {subjectname} ({count})
              </li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <div className="row">
          <div className="container ">
            <div className="datatable-top">
              <div className="d-flex flex-row ">
                <div className="">
                  <div className="datatable-search">
                    <input
                      className="form-control"
                      type="search"
                      placeholder="Search"
                      title="Search within table"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className=" bd-highlight d-flex  col-sm-5">
                <input
                  className="form-control"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  placeholder="Emergency Barcode"
                  value={barcodeCount}
                  onChange={(e) => setBarcodeCount(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-primary ms-2 btn-sm"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Upload Question Paper & Answer Key"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={ExtraBarcode}
                >
                  Emergency
                </button>

                <button
                  type="button"
                  className="btn border border-dark  rounded-circle btn-sm ms-2 p-1 "
                  onClick={() =>
                    navigate('/WithoutBarcode', {
                      state: { id, subjectId, examname, subjectname },
                    })
                  }
                >
                  {' '}
                  <TbBarcodeOff className="barcode-nav-buuton" />
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-circle btn-sm ms-2 p-1 "
                  onClick={() =>
                    navigate('/WithBarcode', {
                      state: { id, subjectId, examname, subjectname },
                    })
                  }
                >
                  {' '}
                  <BiBarcodeReader className="barcode-nav-buuton" />
                </button>
                <button
                  type="button"
                  className="btn btn-primary   rounded-circle btn-sm ms-2 p-1 "
                  onClick={() =>
                    navigate('/EmergencyBarcode', {
                      state: { id, subjectId, examname, subjectname },
                    })
                  }
                >
                  {' '}
                  <MdOutlineManageHistory className="barcode-nav-buuton" />
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable
                columns={baseColumns}
                data={records.filter((record) => {
                  const nameMatches = record.name
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());
                  const rollNumberMatches = record.rollNumber
                    .toString()
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());
                  return nameMatches || rollNumberMatches;
                })}
                progressPending={loading}
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={clearSelectedRows} // Clear selection if no rows are selected
                className="custom-table"
                pagination
                paginationPerPage={rowsPerPage} // Set rows per page
                paginationTotalRows={records.length} // Total number of records
                paginationDefaultPage={currentPage} // Default starting page
                onChangePage={(page) => setCurrentPage(page)} // Update current page
                onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)} // Update rows per page
              />
              <div className="d-flex justify-content-end  mt-3">
                <button
                  onClick={() =>
                    navigate('/ExamDetails', { state: { id, subjectId } })
                  }
                  className="btn btn-primary"
                >
                  <i className="bi bi-arrow-bar-left"></i> Back
                </button>
                <button
                  onClick={sendSelectedStudents}
                  className="btn btn-primary ms-2"
                  disabled={loadingbr}
                >
                  <i className="bi bi-qr-code-scan"></i>
                  {loadingbr ? 'Generating...' : 'Generate '}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Modal for Extra Barcode */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg  modal-dialog-scrollable ">
          <div className="modal-content">
            <div className="modal-header bg-secondary">
              <h5
                className="modal-title text-white p-1 rounded"
                id="exampleModalLabel"
              >
                Generate Emergency Barcodes
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              {extraBarcode.length > 0 ? (
                extraBarcode.map((barcode, index) => (
                  <div key={barcode.id} className="mb-2">
                    <div className="container d-flex justify-content-center align-items-center ">
                      <div className="border border-dark p-1 w-75">
                        <div className="row">
                          <div className="col mt-2 ms-3">
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Roll No: </strong>
                              </div>
                              <div className="">
                                <span></span>
                              </div>
                            </div>
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Exam: </strong>
                              </div>
                              <div className="">
                                <span> {examname}</span>
                              </div>
                            </div>
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Subject: </strong>
                              </div>
                              <div className="">
                                <span> {barcode.barcodeJson.subjectName}</span>
                              </div>
                            </div>
                            <div className="d-flex flex-row ">
                              <div className="barcode-labal">
                                <strong>Sub Code: </strong>
                              </div>
                              <div className="">
                                <span> {barcode.barcodeJson.subjectCode}</span>
                              </div>
                            </div>
                          </div>
                          <div className="col text-end">
                            <div className="text-center">
                              <img
                                src={barcode.barcodeJson.barcodeImage}
                                alt={`Barcode ${index + 1}`}
                                style={{
                                  width: '250px',
                                  height: '100px',
                                  marginBottom: '-7px',
                                }}
                              />
                              <p className="mb-1 mt-0 ">
                                <strong className="text-danger">
                                  {barcode.barcodeNo}
                                </strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No barcodes generated yet.</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success mx-1"
                onClick={() => ERDownloadPDF(extraBarcode, examname)} // This calls the function to generate the PDF
              >
                PDf 100 X 25
              </button>
              <button
                type="button"
                className="btn btn-success mx-1"
                onClick={() => ERDownloadPDFA4(extraBarcode, examname)} // This calls the function to generate the PDF
              >
                A4 21 X 29.7
              </button>

              <button
                type="button"
                className="btn btn-secondary mx-1"
                data-bs-dismiss="modal"
                onClick={() => setExtrabarcode([])}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for main Barcode */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: 'block' }}
          tabIndex="-1"
          aria-labelledby="barcodeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-secondary">
                <h5 className="modal-title text-white" id="barcodeModalLabel">
                  Generate Barcodes
                </h5>
                <button
                  type="button"
                  className="btn "
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div className="modal-body">
                {generatedBarcodes.length > 0 ? (
                  generatedBarcodes.map((barcode) => (
                    <div key={barcode.id} className="mb-2">
                      <div className="container d-flex justify-content-center align-items-center">
                        <div className="border border-dark p-1 w-75">
                          <div className="row">
                            <div className="col mt-2 ms-3">
                              <div className="d-flex flex-row ">
                                <div className="barcode-labal">
                                  <strong>Roll No:</strong>
                                </div>
                                <div className="">
                                  <span>{barcode.studentRollNumber}</span>
                                </div>
                              </div>
                              <div className="d-flex flex-row ">
                                <div className="barcode-labal">
                                  <strong>Exam:</strong>
                                </div>
                                <div className="">
                                  <span>{examname}</span>
                                </div>
                              </div>
                              <div className="d-flex flex-row ">
                                <div className="barcode-labal">
                                  <strong>Subject:</strong>
                                </div>
                                <div className="">
                                  <span>{barcode.subjectName}</span>
                                </div>
                              </div>
                              <div className="d-flex flex-row ">
                                <div className="barcode-labal">
                                  <strong>Sub Code: </strong>
                                </div>
                                <div className="">
                                  <span> {barcode.subjectCode}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col text-end">
                              {barcode.barcodeJson.map(
                                (jsonItem, jsonIndex) => (
                                  <div key={jsonIndex} className="text-center">
                                    <img
                                      src={jsonItem.barcodeImage}
                                      alt={`Barcode ${jsonIndex + 1}`}
                                      style={{
                                        width: '250px',
                                        height: '100px',
                                        marginBottom: '-7px',
                                      }}
                                    />
                                    <p className="mb-1 mt-0">
                                      <strong>{barcode.barcodeNo}</strong>
                                    </p>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No QR Codes generated yet.</p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success mx-1"
                  onClick={() => handleDownloadPDF(generatedBarcodes, examname)} // This calls the function to generate the PDF
                >
                  PDf 100 X 25
                </button>
                <button
                  type="button"
                  className="btn btn-success mx-1"
                  onClick={() =>
                    handleDownloadPDF4(generatedBarcodes, examname)
                  } // This calls the function to generate the PDF
                >
                  A4 21 X 29.7
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-center" style={{ width: 'auto' }} />
    </AdminLayout>
  );
}
